<template>
  <!--
        作者：kmdshop
        时间：2019-10-25
        描述：权限-管理员列表
    -->
  <div class="user">
    <!--添加管理员-->
    <div class="common-level-rail">
      <el-button size="small" type="primary" icon="el-icon-plus" @click="addClick">添加规则</el-button>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="product_id" label="产品" width="300px">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic"><img v-img-url="scope.row.product.image[0]?scope.row.product.image[0].file_path:error_img" alt="" /></div>
                <div class="info">
                  <div class="name">{{ scope.row.product.product_name }}</div>
                  <div class="price">￥{{ scope.row.product.product_price }}</div>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="product_id" label="分类">
              <template slot-scope="scope">
                  <div>{{ scope.row.product.category_id && scope.row.product.category ? scope.row.product.category.name :'' }}</div>
              </template>
          </el-table-column>
          <el-table-column prop="product_id" label="编码">
              <template slot-scope="scope">
                  <div>{{ scope.row.product.product_no }}</div>
              </template>
          </el-table-column>

          <el-table-column prop="product_id" label="平级直推奖励">
              <template slot-scope="scope">
                  <div v-if="scope.row.type==0">{{ scope.row.award }}{{scope.row.award_type==0?'%':'元'}}</div>
                  <div v-if="scope.row.type==1" v-for="(item,index) in scope.row.grade_list" :key="index">{{ item.name }} : {{ item.award }}{{scope.row.award_type==0?'%':'元'}}</div>
              </template>
          </el-table-column>

          <el-table-column prop="product_id" label="平级间推奖励">
              <template slot-scope="scope">
                  <div v-if="scope.row.type==0">{{ scope.row.jaward }}{{scope.row.award_type==0?'%':'元'}}</div>
                  <div v-if="scope.row.type==1" 
                  v-for="(item,index) in scope.row.jgrade_list" 
                  :key="index">{{ item.name }} : {{ item.jaward }}{{scope.row.award_type==0?'%':'元'}}</div>
              </template>
          </el-table-column>
          
          <el-table-column prop="status" label="状态">
              <template slot-scope="scope">
                  <div>{{ scope.row.status==1?'开启':'关闭' }}</div>
              </template>
          </el-table-column>

          <el-table-column prop="create_time" label="添加时间"></el-table-column>
          <el-table-column fixed="right" label="操作" width="90">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="text" size="small" >编辑</el-button>
              <el-button @click="deleteClick(scope.row)" type="text" size="small" >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <Add :open="open_add" :gradeList="gradeList"  :jgradeList="jgradeList"  :form="curAddModel"   @close="closeAdd"></Add>

    <Edit :open="open_edit" :gradeList="grade_list" :jgradeList="jgrade_list" :lateralDradeList="lateral_grade_list" :form="curModel"  @close="closeEdit"></Edit>

     <!--选择商品-->
    <ProductSelect :isproduct="isproduct" :excludeIds="excludeIds" :islist="false" @closeDialog="closeProductDialogFunc($event)">产品列表弹出层</ProductSelect>
  </div>
</template>

<script>
import LateralApi from '@/api/lateral.js';
import Add from './dialog/Add.vue';
import Edit from './dialog/Edit.vue';
import ProductSelect from '@/components/product/Product';
export default {
  components: {
    Add,
    Edit,
    ProductSelect
  },
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*角色是否加载完成*/
      role_loading:true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        user: '',
        region: ''
      },
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      curAddModel: {
        product: {},
        product_id: 0,
        award_type: 0, //奖励类型
        type: 0, //计算类型
        award: 0,
        jaward:0,
        status: 0,
        award_detail: {},
        is_open_grade:0
      },
      /*当前编辑的对象*/
      curModel: {
        id: 0,
        product: {},
        product_id: 0,
        award_type: 0, //奖励类型
        type: 0, //计算类型
        award: 0,
        jaward:0,
        status: 0,
        award_detail: {},
        is_open_grade:0
      },
      /*等级列表*/
      gradeList:[],
      grade_list: [],
      jgradeList:[],
      jgrade_list:[],
       /*是否打开产品弹出层*/
      isproduct: false,
      /*商品需要去重的*/
      excludeIds: [],
      /*是否多选*/
      islist: false,
      lateral_grade_list: [],
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = {};
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      LateralApi.getProduct(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
          self.gradeList = data.data.gradeList;
          self.jgradeList = data.data.jgradeList;
          self.role_loading = false;
        })
        .catch(error => {});
    },

    /*打开添加*/
    addClick() {
      if(!this.role_loading){
         this.open_add=true;
      }
    },

    /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.curAddModel.product = {};
      this.curAddModel.product_id = 0;
      if(e.type=='success'){
        this.getTableList();
      }
    },

    /*打开编辑*/
    editClick(row) {
      console.log(row);
      this.curModel = row;
      this.grade_list = row.grade_list;
      console.log("row.grade_list",row.grade_list)
      this.jgrade_list = row.jgrade_list;
      console.log("row.jgrade_list",row.jgrade_list)
      this.open_edit=true;
      this.lateral_grade_list = row.lateral_grade_list;
    },

    /*关闭添加*/
    closeEdit(e){
      this.open_edit=false;
      this.curModel = {
        id: 0,
        product: {},
        product_id: 0,
        award_type: 0, //奖励类型
        type: 0, //计算类型
        award: 0,
        jaward:0,
        status: 0,
        award_detail: {},
      };
      this.grade_list = [];
      this.jgrade_list = [];
      if(e.type=='success'){
        this.loading = false;
        this.tableData = [];
        this.curPage = 1;
        this.getTableList();
      }
    },


    /*商品选择列表弹出层*/
    openProduct(product, islist) {
      if(product){
        this.excludeIds = [product.product_id];
      }
      this.islist = false;
      this.isproduct = true;
    },

    // /*商品选择关闭弹窗*/
    closeProductDialogFunc(e) {
      if (this.curAddModel == null) {
        return;
      }
      this.isproduct = false;
      if (e.type == 'success') {
        this.curAddModel.product= { product_id: e.params.product_id, product_image: e.params.image,product_name: e.params.product_name,product_price: e.params.product_price };
        this.curAddModel.product_id = e.params.product_id;
      }
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          LateralApi.delProduct(
            {
              id: row.id
            },
            true
          )
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: '删除成功',
                  type: 'success'
                });
                //刷新页面
                self.getTableList();
              } else {
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {});
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/lateral/product/index.vue